import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('set_up_conditions_for_the_approval_steps'),
    subtitle: defineMessage('next_you_will_create_ap_to_see_how_simple_it_is'),
    description: defineMessage('if_you_click_not_now_yo__documents_at_all_steps'),
    goToConditions: defineMessage('go_to_conditions'),
    notNow: defineMessage('not_now'),
};
